import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";

import Card from "components/card";
import TransectionTable from "./TransectionTable";
import PopUpAlertModal from "components/modals/popUpAlertModal";

import { fetchTransectionListThunk } from "slices/transectionSlice";
import { columnsTransectionDataColumns } from "../tables/variables/columnsData";

const TransectionPage = ({ type,appId,userId }) => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const itemsPerPage = 5;

const transectionState = useSelector((state) => state.transection?.data?.data || []);
console.log("hello",transectionState)
// If your redux data is directly an array of transactions:
const transectionList = Array.isArray(transectionState) ? transectionState : transectionState?.transectionList || [];

// Now map the data safely
const mappedTransactions = transectionList.map((item) => ({
  ...item,
  userName: item?.userId?.name || "N/A",
  userEmail: item?.userId?.email || "N/A",
  appId: item?.appId?.app_id || "N/A",
}));

// Pagination logic
const pagedTransactions = mappedTransactions.slice((page - 1) * itemsPerPage, page * itemsPerPage);
const totalPages = Math.ceil(mappedTransactions.length / itemsPerPage);

console.log("hello",appId)
  useEffect(() => {
    if (type === "transactions-all") {
      dispatch(fetchTransectionListThunk({type}));
    }
    if(type==="transactions-app"){
        let id=appId;
          dispatch(fetchTransectionListThunk({type,id}));
    }
       if(type==="user-transection"){
        dispatch(fetchTransectionListThunk({ type, id: userId }));
    }
  }, [type, dispatch,appId]);

  const handleDelete = (id) => {
    setSelectedId(id);
    setOpenAlert(true);
  };

  return (
    <div className="p-4">
      <PopUpAlertModal
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        title="Are you sure you want to delete this transaction?"
        clickHandler={() => {
          // dispatch(deleteTransactionThunk(selectedId)) // if you have a delete thunk
          setOpenAlert(false);
        }}
      />

      <div className="flex justify-around w-full mt-4">
        <Card className="w-1/3 bg-white rounded-md p-4 m-1 font-bold">Total Transection: {pagedTransactions?.length || 0}</Card>
        <Card className="w-1/3 bg-white rounded-md p-4 m-1 font-bold">Pending Transection: {pagedTransactions?.filter((item)=>item?.status=="pending")?.length || 0}</Card>
        <Card className="w-1/3 bg-white rounded-md p-4 m-1 font-bold">Failed Transection: {pagedTransactions?.filter((item)=>item?.status=="failed")?.length || 0}</Card>
         <Card className="w-1/3 bg-white rounded-md p-4 m-1 font-bold">Complete Transection: {pagedTransactions?.filter((item)=>item?.status=="completed")?.length || 0}</Card>
      </div>

      <div className="mt-5 grid h-full grid-cols-1 gap-5">
        <TransectionTable
          title="Transaction Table"
          columnsData={columnsTransectionDataColumns}
          tableData={pagedTransactions}
          // deleteHandler={handleDelete} // Pass this if needed
        />

        {totalPages > 1 && (
          <div className="flex gap-2 justify-center my-2">
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>
              <MdSkipPrevious />
            </button>
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => setPage(i + 1)}
                className={i + 1 === page ? "font-bold" : ""}
              >
                {i + 1}
              </button>
            ))}
            <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>
              <MdSkipNext />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransectionPage;
